import React, { useEffect } from "react";
import { ClientType } from "../../redux/auth/authTypes";
import { CommonHeader, Loader } from "../../components/commons";
import { UserIcon } from "../../components/Icon";
import { ClientDashboardCard } from "../../components/ClientDashboard";
import { MODULES_LIST } from "../../constant/modules";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/rootReducers";
import { connect } from "react-redux";
import { useMenuCheck } from "../../customHooks/useMenuCheck";
import { setClientCurrencyDetails } from "../../redux/auth";
import {  getClientColumnAssignedListAction, resetIsClientColumnAssignedMessage, resetIsClientColumnAssignedSuccess, resetSingleInvoiceDetails } from "../../redux/invoiceGeneration";
import {  GetClientColumnAssignedPayloadType } from "../../commonTypes/invoiceGenerationTypes";
import { NoColumnAssignedBanner } from "../../assets/images";

type AppProps = {
  history: any;
  clientData?: ClientType;
  modules: any[];
  token: string | null;
  redirectToclientDashboard: (clientCode: number | string | undefined) => void;
  dispatchSetCurrencyDetails: (clientCode: number | string | undefined) => void;
  dispatchResetSingleInvoiceDetails: () => void;
  clientCurrencyName: string | undefined;
  clientCurrencyShortForm: string | undefined;
  clientCurrencySign: string | undefined;
  dispatchGetClientColumnAssignedListAction: (
      data: GetClientColumnAssignedPayloadType
    ) => void;
    isClientColumnAssignedSuccess:number|null;
    isClientColumnAssignedMessage:string|null;
    dispatchResetIsClientColumnAssignedSuccess:()=>void;
    dispatchResetIsClientColumnAssignedMessage:()=>void;
    fetching:boolean;
};

const ClientDashboard = ({
  history,
  token,
  modules,
  clientCurrencyName,
  clientCurrencyShortForm,
  clientCurrencySign,
  dispatchSetCurrencyDetails,
  dispatchResetSingleInvoiceDetails,
  dispatchGetClientColumnAssignedListAction,
  isClientColumnAssignedSuccess,
  isClientColumnAssignedMessage,
  dispatchResetIsClientColumnAssignedSuccess,
  dispatchResetIsClientColumnAssignedMessage ,
  fetching

}: AppProps) => {
  const client_code =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.client_code
      ? history.location.state.client_code
      : 0;

  const company_name =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.company_name
      ? history.location.state.company_name
      : "";
  const currencyDetails =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.currencyDetails
      ? history.location.state.currencyDetails
      : {
          currencySign: clientCurrencySign,
          currencyName: clientCurrencyName,
          currencyShortForm: clientCurrencyShortForm,
        };

  const loginData = useSelector((state: RootState) => state.auth.loginData);
  const isClient = loginData?.is_client;
  const userRoleId = loginData?.user_role_id;

  const withoutOpenItems = MODULES_LIST.filter(
    (menuName) => menuName.name !== "Open Items"
  );
  const finalMenuList =
    isClient || userRoleId === 1 ? MODULES_LIST : withoutOpenItems;

  const [isExpenseEntryPresent, setIsExpenseEntryPresent] = useMenuCheck();
  const [isSalesEntryPresent, setIsSalesEntryPresent] = useMenuCheck();
  const [isOthersEntriesPresent, setIsOthersEntriesPresent] = useMenuCheck();
  useEffect(() => {
    setIsOthersEntriesPresent("Other Entries", "menu");
    setIsSalesEntryPresent("Sales Invoices", "menu");
    setIsExpenseEntryPresent("Expense Invoices", "menu");
    dispatchSetCurrencyDetails(currencyDetails);
    dispatchResetSingleInvoiceDetails();


  }, []);

 

  const renderCardList = () => {
    let accessedCard: any = [];
    let requestAccessCard: any = [];
    modules?.map((item: any) => {
      if (item?.coming_soon === 0) {
        accessedCard.push(item);
      } else {
        requestAccessCard.push(item);
      }
    });
    return [...accessedCard, ...requestAccessCard];
  };

  const renderModules = () => {
    let arrangedCard: any = renderCardList();

    let finalList = arrangedCard?.map((list: any) => {
      return (
        <div className={`col-md-4 mb-4 ${list.extraClasses}`}>
          <ClientDashboardCard 
            isNew={list.is_new}
            key={list.finac_key}
            name={list.menu_name}
            description={list.description}
            icon={<i className={list.icon}></i>}
            action={() => handleRedirection(list.action)}
            comingSoon={list.coming_soon}
          />
        </div>
      );
    });

    return finalList;
  };

  const handleRedirection = (moduleName: string | undefined) => {
    switch (moduleName) {
      case "redirectToInvoiceList":
        return redirectToInvoiceList();
      case "redirectToUploadDocument":
        return redirectToUploadDocument();
      case "redirectToJobTracker":
        return redirectToJobTracker();
      case "redirectToInsights":
        return redirectToInsights();
      case "redirectToInsightsAdvanced":
        return redirectToInsightsAdvanced();
      case "redirectToOpenItems":
        return redirectToOpenItems();
      case "redirectToClientSettings":
        return redirectToClientSettings();
      case "redirectToInvoiceGeneration":
        return InvoiceGeneration();
      case "redirectToReports":
        return redirectToReports();
      case "redirectToClientIdPasswordManager":
        return redirectToClientIdPasswordManager();
      case "redirectToGst":
        return redirectToGst();
      case "redirectToComplianceCalendar":
        return redirectToComplianceCalendar();
      case "redirectToFixedAssetRegister":
        return redirectToFixedAssetRegister();
      case "redirectToSopModule":
        return redirectToSopModule();
      default:
        return null;
    }
  };

  const redirectToInvoiceList = () => {
    history.push({
      pathname: `/invoice/${client_code}`,
      state: { client_code, company_name },
    });
  };

  const redirectToUploadDocument = () => {
    history.push({
      pathname: `/file-manager/${client_code}/folder/${0}`,
      state: { client_code, company_name },
    });
  };

  const redirectToJobTracker = () => {
    history.push({
      pathname: `/job-tracker-list/${client_code}`,
      state: { client_code, company_name },
    });
  };

  const redirectToInsights = () => {
    history.push({
      pathname: `/insights/${client_code}`,
      state: { client_code, company_name },
    });
  };
  const redirectToInsightsAdvanced = () => {
    history.push({
      pathname: `/insights-advanced-summary/${client_code}`,
      state: { client_code, company_name },
    });
  };

  const redirectToOpenItems = () => {
    history.push({
      pathname: `/open-items-client/${client_code}`,
      state: { client_code, company_name },
    });
  };

  const redirectToClientSettings = () => {
    history.push({
      pathname: `/client-settings/${client_code}`,
      state: { client_code, company_name },
    });
  };

  const InvoiceGeneration = () => {
    history.push({
      pathname: `/invoice-generation/${client_code}${
        isExpenseEntryPresent
          ? "#expenses"
          : isSalesEntryPresent
          ? "#revenues"
          : "#others"
      }`,
      state: { client_code, company_name },
    });
  };

  const redirectToReports = () => {
    history.push({
      pathname: `/reports/${client_code}`,
      state: { client_code, company_name },
    });
  };
  const redirectToClientIdPasswordManager = () => {
    history.push({
      pathname: `/client-id-password-manager/${client_code}`,
      state: { client_code, company_name },
    });
  };
  const redirectToGst = () => {
    history.push({
      pathname: `/gst/${client_code}`,
      state: { client_code, company_name },
    });
  };
  const redirectToComplianceCalendar = () => {
    history.push({
      pathname: `/compliance-calendar/${client_code}`,
      state: { client_code, company_name },
    });
  };
  const redirectToFixedAssetRegister = () => {
    history.push({
      pathname: `/fixed-asset-register/${client_code}`,
      state: { client_code, company_name },
    });
  };
  const redirectToSopModule = () => {
    history.push({
      pathname: `/sops/${client_code}`,
      state: { client_code, company_name },
    });
  };
  return (
    <div>
      <CommonHeader title="Client Dashboard" />
      <div className="d-flex align-items-center">
        {client_code ? (
          <>
            <UserIcon /> &nbsp;
            {company_name} {"(" + client_code + ")"}
          </>
        ) : null}

      </div>
      {/* FUTURE USE */}
      {/* {(isClientColumnAssignedMessage==="Columns are not assigned to client!" && isClientColumnAssignedSuccess===0)?
      <div className="mt-3"><img src={NoColumnAssignedBanner}/></div>:""
       }  */}

      <div className="row mt-3">{renderModules()}</div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  modules: state.auth.modules,
  token: state.auth.token,
  clientCurrencyName: state.auth.currencyName,
  clientCurrencyShortForm: state.auth.currencyShortForm,
  clientCurrencySign: state.auth.currencySign,
  isClientColumnAssignedSuccess:state.invoiceGeneration.isClientColumnAssignedSuccess,
  isClientColumnAssignedMessage:state.invoiceGeneration.isClientColumnAssignedMessage,
  fetching:state.invoiceGeneration.fetching
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchSetCurrencyDetails: (data: any) =>
    dispatch(setClientCurrencyDetails(data)),
  dispatchResetSingleInvoiceDetails: () =>
    dispatch(resetSingleInvoiceDetails()),

  dispatchGetClientColumnAssignedListAction: (data: GetClientColumnAssignedPayloadType) =>
  dispatch(getClientColumnAssignedListAction(data)),
  dispatchResetIsClientColumnAssignedSuccess: () => dispatch(resetIsClientColumnAssignedSuccess()),
  dispatchResetIsClientColumnAssignedMessage: () => dispatch(resetIsClientColumnAssignedMessage()),

});

export default connect(mapStateToProps, mapDispatchToProps)(ClientDashboard);
